import type React from 'react'
import styled from 'styled-components'

import { validationToHeaderText } from '@/types/Activity'
import type { Income as IncomeT } from '@/types/Activity'
import { Colours } from '@/utils/styles'

interface Props {
  income: IncomeT
}

const Container = styled.span`
  display: inline;
  text-transform: capitalize;
  color: ${Colours.blue};
`

export const getIncomeLabel = (
  type: string,
  status: string,
  directorPayType?: string,
) => {
  switch (type.toLowerCase()) {
    case 'employment': {
      const isDirector = !!directorPayType
      return isDirector ? `${status} (Director)` : status
    }
    case 'student':
      return status === 'Finance' ? 'Student' : 'Student Scholarship/Bursary'
    default:
      return type
  }
}

const IncomeTypeLabel: React.FC<Props> = ({
  income: { type, status, validation, directorPayType },
  children,
}) => {
  const label = getIncomeLabel(type, status, directorPayType)
  return (
    <Container>
      <span>{children}</span>
      <span>{label}</span> -{' '}
      <span style={{ color: Colours.teal }}>{validationToHeaderText(validation)}</span>
    </Container>
  )
}

export default IncomeTypeLabel
